import { CHAT_MESSAGE_ERROR_FRAME_TYPE } from './chat.constants';
import { IChatIncomingFrame, IChatMessageError } from './chat.interfaces';


export function isChatMessageError(frame: IChatIncomingFrame): frame is IChatMessageError {
  return (frame as IChatMessageError)?.type === CHAT_MESSAGE_ERROR_FRAME_TYPE;
}

/** Flattens either `detail` shape into one displayable line. */
export function chatErrorDetailToText(detail: IChatMessageError['detail']): string {
  if (typeof detail === 'string') {
    return detail;
  }

  return Object.keys(detail || {}).map((field) => detail[field]).join(' ');
}
